export default "__VITE_ASSET__946bd2fa__"